import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useRecordContext,
    required,
    NumberInput,
    minValue,
} from 'react-admin';

import FileUpload from '../../common/inputs/FileUpload';
import { EditToolbar } from '../../common/EditToolbar';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import PermissionGuard from '../../common/PermissionGuard';
import useIsPermission from '../../hooks/useIsPermission';
import TestimonialCategoryAutoComplete from './TestimonialCategoryAutoComplete';

const TestimonialEdit = () => {
    const { isUpdatable } = useIsPermission('TESTIMONIALS');
    return (
        <PermissionGuard permission={isUpdatable}>
            <Edit mutationMode="pessimistic" title={<TestimonialTitle />}>
                <SimpleForm toolbar={<EditToolbar />}>
                    <FileUpload type="VIDEO_THUMBNAIL" source="authorImage" required={true} />
                    <TextInput source="authorName" fullWidth validate={[required()]} />
                    <NumberInput source="displayOrder" fullWidth validate={[required(), minValue(1)]} />
                    <HTMLEditorInput
                        source="description"
                        fullWidth
                        validate={[required(), validHtml]}
                    />
                    <TestimonialCategoryAutoComplete fullWidth validate={[required()]} />
                </SimpleForm>
            </Edit>
        </PermissionGuard>
    );
};

const TestimonialTitle = () => {
    const record = useRecordContext();
    return record ? <span>{record.authorName}</span> : null;
};

export default TestimonialEdit;
